"use strict";

/*exported SchedulingInfo */
class SchedulingInfo {
	constructor() {
		this.selected_date = false;
		this.available_times = [];
		this.selected_event_id = false;
		this.selected_time = false;
		this.notes = '';
		this.order_id = false;

		// New Attendee System
		this.reservation_attendees = false;
		this.children_attendees = false;
		this.paid_adult_attendees = false;
		this.chaperone_attendees = false;
		this.addon_attendees = false;

		// Class grades
		this.class_grade = false;

		// Class info questions
		this.class_info_questions = [];

		// Deposit system
		this.paytype_selected = null;
		this.amount_to_pay = null; // full or deposit
	}
}

/*exported QuestionAnswer */
class QuestionAnswer {
	/**
	 * @param { number } index 
	 * @param { Object } source_question 
	 * @param { string } answer 
	 */
	constructor(index, source_question, answer) {
		this.index = index;
		this.source_question = source_question;
		this.answer = answer;
	}
}

/*exported InnerScreen */
class InnerScreen {
	/**
	 * @param {HTMLElement} inner_elem 
	 * @param {int} index 
	 */
	constructor(inner_elem, index) {
		this.inner_elem = inner_elem;
		this.index = index;
		this.button_wrapper = null;
		this.Prepare = () => {};
		this.Show = () => {};
		this.Reset = () => {};
		this.RecallButtons = () => {
			if (this.button_wrapper) {
				this.button_wrapper.remove();
			}
		};

		/**
		 * When user inputs indicate the screen can move forward
		 */
		this.ScreenIsValid = () => {};

		/**
		 * When user inputs should prevent the screen from moving forward
		 */
		this.ScreenIsInvalid = () => {};

		/**
		 * When user inputs should trigger a refresh to any ajax features that are bound to the screen.
		 */
		this.RefreshAjax = () => {};
	}
}

/*exported Block */
class Block {
	/**
	 * @param {HTMLElement} container 
	 * @param {CallableFunction} on_nothing
	 */
	constructor(container, on_nothing) {
		this.container = container;
		this.grid_elem = container.querySelector('.grid');
		this.overlay_content_elem = container.querySelector('.topic-overlay-contents');
		this.overlay_screen_buttons_elem = container.querySelector('.topic-overlay-contents .screen-buttons');
		this.overlay_screen_right_port_elem = container.querySelector('.screen-right-port');
		this.topic_card_links = container.querySelectorAll('.link-wrapper');

		// Calendar
		this.calendar_elem = container.querySelector('.highlighted-dates');
		this.calendar = false; // Calendar JS object
		this.calendar_settings = {}; // Settings for the calendar JS object
		this.todays_date = false; // We will refresh this from the server when we check educator session
		this.calendar_date_clicked_events = []; // These functions fire when controller.SelectDate happens.
		this.calendar_date_selection_cleared_events = []; // Happens when a reset to the selected date happens

		// Topic data is stored in themejs variables and loaded via topic_id found in the individual cards
		this.current_topic = false;

		// All screens organized by outer screen objects
		this.all_screens = [];

		// Indexes pointing to the screen found in `all_screens`
		this.current_screen = {
			// 0 = main two column split, 1 = full width for contact info collection (anonymous)
			outer: 0,

			// 0 through 6 scheduling progress
			inner: 0
		};

		// Data needed for contact submission associated with scheduling
		this.contact_info = {
			// Auth Status
			anon: true,

			// Anonymous Only
			firstname: '',
			lastname: '',
			email: '',
			phone: '',
			street_address1: '',
			city: '',
			state: 'CA',
			zip: '',
			school: false,
			school_name: '' // this is only used for display purposes
		};

		this.scheduling_info = new SchedulingInfo(); //Form data collected regarding scheduling the topic/event

		// Develforms Progressive Page Processing
		this.d3df_page_options = {
			pageIndex: 0,
			submissionID: false,
			onSuccess: on_nothing
		};

		// Stripe payment element
		this.stripe_elements = null;
		this.stripe_payment_element = null;
	}
}

/*exported SelectAttendeesVariant */
class SelectAttendeesVariant {
	/**
	 * @param {string} key 
	 * @param {HTMLElement} select_attendees_elem
	 * @param {Block} block
	 * @param {InnerScreen} screen
	 * @param {SelectAttendeesVariant} addOn
	 */
	constructor(key, select_attendees_elem, block, screen, addOn) {
		this.key = key;
		this.select_attendees_elem = select_attendees_elem;
		this.block = block;
		this.screen = screen;
		this.addOn = addOn;
	}

	setup() {

	}

	show() {

	}
}
